function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
import { Debounce } from '@/utils/validate';
export default {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      supplierId: '',
      brandOption: [],
      listData: []
    };
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit() {
      var selectLists = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var supplierId = arguments.length > 1 ? arguments[1] : undefined;
      this.listData = selectLists;
      this.supplierId = supplierId;
      this.pram = {};
      this.visible = true;
    },
    handerSubmit: Debounce(function (form) {
      var _this = this;
      this.loading = true;
      suplierCouponsApi.batchChangeAmt({
        supplierId: this.supplierId,
        supplierList: this.listData.length && this.listData.map(function (item) {
          var _ref = item || {},
            priceType = _ref.priceType,
            corrAmount = _ref.corrAmount,
            id = _ref.id;
          return {
            priceType: priceType,
            corrAmount: corrAmount,
            id: id
          };
        }) || []
      }).then(function (data) {
        _this.$message.success('操作成功');
        _this.loading = false;
        _this.visible = false;
        _this.$emit('doRefresh');
      }).catch(function () {
        _this.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    // 批量调整
    batchHander: function batchHander() {
      var _this$pram = this.pram,
        priceType = _this$pram.priceType,
        corrAmount = _this$pram.corrAmount;
      var list = _toConsumableArray(this.listData) || [];
      this.listData = list.length && list.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          priceType: priceType,
          corrAmount: corrAmount
        });
      });
    }
  }
};